import React, { useState, useEffect, useMemo } from "react";
import CubeLock from "../../../origami/components/puzzles/CubeLock";
import { trackError } from "../../../../lib/metrics";
import { useInspections } from "../../../../hooks/useInspections";
import { useHints } from "../../../../hooks/useHints";
import { ModalRegister, Modal } from "../../../../components/ui/ModalRegister";
import { EmployeeRegister } from "../../../origami/components/puzzles/EmployeeRegister";
import RaisedHandsBadge from "../../../../components/ui/RaisedHandsBadge";
import CubeGrabZone from "../../../origami/components/puzzles/CubeGrabZone";
import { useInspectProgress } from "../../../../hooks/useInspectProgress";
import InspectProgressChip from "../../../../components/ui/InspectProgressChip";
import { useMissionGuide } from "../../../../hooks/useMissionGuide";
import { getInspectKeys } from "../../../../data/inspectables";
import AnimalCategoriesPuzzle from "../../../origami/components/puzzles/AnimalCategoriesPuzzle";
import HintsModalHub from "../../../../components/ui/HintsModalHub";
import EmpathieScannerPuzzle from "../../../origami/components/puzzles/EmpathieScannerPuzzle";
import AnimalIconCodeLock from "../../../origami/components/puzzles/AnimalIconCodeLock";
import CompletePlant from "../../../origami/components/puzzles/CompletePlant";
import PlantFragmentPuzzle from "../../../origami/components/puzzles/PlantFragmentPuzzle";
import ErasedWhiteboardPuzzle from "../../../origami/components/puzzles/ErasedWhiteboardPuzzle";
import OrigamiCommunicationModal from "../../../origami/components/ui/OrigamiCommunicationModal";
import { useOrigamiReboot } from "../../../../hooks/useOrigamiReboot";
import { rebootText } from "../../../../data/origami/origamiTexts";

export default function Six_Players_Stage1_Player6({
  code,
  playerId,
  hintSignal,
  raisedCount,
  raisedPlayers,
  centerMaxH,
  pseudo,
}) {
  const INSPECT_KEYS = useMemo(() => {
    return getInspectKeys({
      gameId: 1,
      playerCount: 6,
      stage: 1,
      seat: 6,
    });
  }, []);
  const [backgroundUrl] = useState("/assets/s1-p6-room.webp");
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showHintModal, setShowHintModal] = useState(false);

  const [showCubesModal, setShowCubesModal] = useState(false);
  const [showPostItModal, setShowPostItModal] = useState(false);
  const [showCharterModal, setShowCharterModal] = useState(false);
  const [hasRegistryAccess, setHasRegistryAccess] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [puzzleSequence, setPuzzleSequence] = useState([]);
  const [codeInput, setCodeInput] = useState("");
  const [codeError, setCodeError] = useState("");

  const [showAnimalsPuzzleModal, setShowAnimalsPuzzleModal] = useState(false);
  const [animalsClassified, setAnimalsClassified] = useState(false);
  const [showAnimalsPuzzleInline, setShowAnimalsPuzzleInline] = useState(false);
  const [showDrawerModal, setShowDrawerModal] = useState(false);
  const [drawerUnlocked, setDrawerUnlocked] = useState(false);

  const [colorblindModeDicesP6, setColorblindModeDicesP6] = useState(false);

  const [bgReady, setBgReady] = useState(false);

  const [showPlantModal, setShowPlantModal] = useState(false);
  const [showPaperModal, setShowPaperModal] = useState(false);
  const [showWhiteboardModal, setShowWhiteboardModal] = useState(false);
  const [showDeskDrawerModal, setShowDeskDrawerModal] = useState(false);
  const [deskDrawerUnlocked, setDeskDrawerUnlocked] = useState(false);
  const [deskDrawerCode, setDeskDrawerCode] = useState("");
  const [deskDrawerError, setDeskDrawerError] = useState("");
  const [fragmentCode, setFragmentCode] = useState("");

  const [hasUvLamp, setHasUvLamp] = useState(false);

  const { inspectedCount, total } = useInspectProgress({
    sessionCode: code,
    stage: 1,
    playerId: Number(playerId),
    keys: INSPECT_KEYS,
  });

  const { showOrigamiReboot, setShowOrigamiReboot } = useOrigamiReboot({
    code,
    playerId,
  });

  const usedStorageKey = useMemo(() => {
    return `hints_used:${code}:s1:p${playerId}`;
  }, [code, playerId]);

  useEffect(() => {
    if (!hintSignal) return;
    setShowHintModal(true);
  }, [hintSignal]);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(`p6:dices:colorblind:${code}:${playerId}`);
      if (saved === "1") setColorblindModeDicesP6(true);
    } catch { }
  }, [code, playerId]);

  useEffect(() => {
    try {
      localStorage.setItem(
        `p6:dices:colorblind:${code}:${playerId}`,
        colorblindModeDicesP6 ? "1" : "0"
      );
    } catch { }
  }, [colorblindModeDicesP6, code, playerId]);

  const handleCubeClick = (index) => {
    setPuzzleSequence((prev) => [...prev, index]);
    console.log("[J6] cube cliqué", index);
  };

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    const trimmed = codeInput.trim();

    if (trimmed === "153") {
      setHasRegistryAccess(true);
      setCodeError("");
      missionUnlock({
        key: "s1.p6.rhRegister.found",
        text: `${pseudo} a trouvé le registre des employés.`,
      });
      missionResolve({ key: "s1.p6.safe.found" })
    } else {
      trackError({
        sessionCode: code,
        stage: 1,
        playerId,
        reason: "wrong_safe_code",
      });

      setHasRegistryAccess(false);
      setCodeError(
        `Le clavier émet un bip sec. Manifestement, ce n'est pas la bonne combinaison.`
      );
    }
  };

  const { markInspectedOnce } = useInspections({
    sessionCode: code,
    stage: 1,
    playerId: Number(playerId),
  });

  const { markHintUsedOnce } = useHints({
    sessionCode: code,
    stage: 1,
    playerId: Number(playerId),
  });

  const { missionUnlock, missionResolve } = useMissionGuide({
    code,
    playerId,
    stage: 1,
  });

  useEffect(() => {
    const k = `p6:animalsSolved:${code}:${playerId}`;
    const raw = localStorage.getItem(k);
    if (raw === "1") setAnimalsClassified(true);
  }, [code, playerId]);


  useEffect(() => {
    setBgReady(false);
  }, [backgroundUrl]);

  const safeImg = "/assets/p6_safe.webp";
  const postItImg = "/assets/p6_postIt.webp";
  const dicesImg = "/assets/p6_dices.webp";
  const charterImg = "/assets/p6_charter.webp";
  const drawerImg = "/assets/p6_drawer.webp";

  const plantImg = "/assets/p6_plant.webp";
  const paperImg = "/assets/p6_paper.webp";
  const whiteboardImg = "/assets/p6_whiteboard.webp";
  const deskDrawerImg = "/assets/p6_desk_drawer.webp";

  const closeHints = React.useCallback(() => setShowHintModal(false), []);

  const handleDeskDrawerSubmit = (e) => {
    e.preventDefault();
    const trimmed = deskDrawerCode.trim();

    if (trimmed === fragmentCode || trimmed === "24681") {
      setDeskDrawerUnlocked(true);
      setHasUvLamp(true); // Donne accès à la lampe UV
      setDeskDrawerError("");
    } else {
      trackError({
        sessionCode: code,
        stage: 1,
        playerId,
        reason: "wrong_desk_drawer_code",
      });
      setDeskDrawerError("❌ Ce n'est pas le bon code.");
    }
  };

  const hintCategories = useMemo(() => {
    // Phase 1 : ouvrir le coffre
    return [
      {
        id: "safe",
        title: "Coffre mural",
        subtitle: "Trouver le code à 3 chiffres",
        hintKeyPrefix: "s1:p6:safe",
        levels: {
          l1: (
            <>
              <p>
                Ce coffre n’est pas là pour décorer : quelqu’un a laissé des indices “trop visibles” sur le bureau.
              </p>
            </>
          ),
          l2: (
            <>
              <p className="mt-3">
                Regarde bien les dés et ce qu'il manque dessus.
              </p>
              <p className="mt-2 text-xs text-gray-300">
                Tu dois obtenir un <span className="text-indigo-200">code à 3 chiffres</span>.
              </p>
            </>
          ),
          l3: (
            <>
              <p>
                Les couleurs indiquées sur le post-it peuvent t'aider.
              </p>
            </>
          ),
          answer: (
            <>
              <p className="text-sm text-red-200 font-semibold">Réponse (coffre)</p>
              <p className="mt-2 text-xs text-gray-200">
                Code du coffre : <span className="font-bold text-amber-200">153</span>
              </p>
            </>
          ),
        },
      },
      {
        id: "register",
        title: "Registre RH",
        subtitle: "Comment l'utiliser",
        hintKeyPrefix: "s1:p6:register",
        levels: {
          l1: (
            <>
              <p className="mb-2">
                Le registre RH n’est pas décoratif : il sert à relier un ID à une personne.
              </p>
            </>
          ),
          l2: (
            <>
              <p className="mb-2">
                Il y a un ID important à retrouver dans le registre.
              </p>
            </>
          ),
          l3: (
            <>
              <p className="mb-2">
                Une fois l&apos;ID trouvé, tu sais <span className="italic">qui</span> vise l’énigme.
                Il te reste à trouver <span className="italic">quoi</span> (l’indice perso).
              </p>
              <p className="text-xs text-gray-300">
                Recoupe les informations obtenues avec le registre avec les infos trouvées ailleurs.
              </p>
            </>
          ),
          answer: (
            <>
              <p className="text-sm text-red-200 font-semibold">Réponse (Registre RH)</p>
              <ul className="mt-2 text-xs text-gray-200 list-disc pl-5 space-y-1">
                <li>
                  ID cible : <span className="font-semibold">359</span> →{" "}
                  <span className="font-semibold">Marie Dupont</span>
                </li>
                <li>Indice clé à récupérer ensuite : le nom de son chat.</li>
              </ul>
            </>
          ),
        },
      },
      {
        id: "annex",
        title: "Annexe — Animaux déclarés",
        subtitle: "Reconstituer la liste",
        hintKeyPrefix: "s1:p6:animals",
        levels: {
          l1: (
            <>
              <p className="mb-2">
                L’annexe est séparée du registre : elle ressemble à une liste “à remettre au propre”.
              </p>
              <p className="text-xs text-gray-300">
                Classe les animaux par catégories : c’est une logique simple mais stricte.
              </p>
            </>
          ),
          l2: (
            <>
              <p className="mb-2">
                Ne cherche pas le propriétaire : ici, on te demande juste de trier correctement.
              </p>
              <p className="text-xs text-gray-300">
                Quand tout est bien classé, l’annexe devient exploitable.
              </p>
            </>
          ),
          l3: (
            <>
              <p className="mb-2">
                Il y a 4 familles attendues : chats / chiens / hamster / araignée.
              </p>
              <p className="text-xs text-gray-300">
                Si un élément te paraît “bizarre”, c’est probablement sa catégorie qui est le piège.
              </p>
            </>
          ),
          answer: (
            <>
              <p className="text-sm text-red-200 font-semibold">Réponse (annexe)</p>

              <div className="mt-2 space-y-2 text-xs text-gray-200">
                <div>
                  <p className="font-semibold text-slate-100">Chats</p>
                  <p className="text-slate-200">
                    Hobbes · Alpi · Blacky · Nala · Chameau · Frippon · Nougat · Caramel
                  </p>
                </div>

                <div>
                  <p className="font-semibold text-slate-100">Chiens</p>
                  <p className="text-slate-200">
                    Savane · Balthazar · Choco · Baloo · Simba · Harissa
                  </p>
                </div>

                <div>
                  <p className="font-semibold text-slate-100">Hamsters</p>
                  <p className="text-slate-200">Pixel</p>
                </div>

                <div>
                  <p className="font-semibold text-slate-100">Araignée</p>
                  <p className="text-slate-200">Spira</p>
                </div>
              </div>
            </>
          ),

        },
      },
      {
        id: "drawer",
        title: "Tiroir vérouillé & Extrait des logs",
        subtitle: "Trouver le code",
        hintKeyPrefix: "s1:p6:drawer",
        levels: {
          l1: (
            <>
              <p>
                Tu auras besoin d'autres informations présentes dans la salle pour dévérouiller ce tiroir.
              </p>
            </>
          ),
          l2: (
            <>
              <p>
                L'annexe des animaux te permet de comprendre combien d'animaux de chaque type existent.
              </p>
            </>
          ),
          l3: (
            <>
              <p>
                Scanne le texte et observe bien les vibrations.
              </p>
            </>
          ),
          answer: (
            <>
              <p className="text-sm text-red-200 font-semibold">Réponse</p>
              <p className="mt-2 text-xs text-gray-200">
                Les lettres qui vibrent quand tu actives le scann forment un mot.
              </p>
              <p className="mt-2 text-xs text-gray-200">
                Mot de passe : <span className="font-bold text-amber-200">Empathie</span>
              </p>
            </>
          ),
        },
      },
    ];
  }, [hasRegistryAccess]);


  return (
    <div className="relative min-h-[calc(100vh)] w-full bg-black text-white flex items-center justify-center">
      {/* 🎯 Cadre 16/9 */}
      <div
        className="relative h-screen w-auto mx-auto aspect-square"
        style={{ maxHeight: centerMaxH ? `${centerMaxH}px` : undefined }}
      >
        <div className="absolute right-4 top-4 z-40 flex items-center gap-2 w-fit">
          <InspectProgressChip inspectedCount={inspectedCount} total={total} />
          <RaisedHandsBadge count={raisedCount} players={raisedPlayers} />
        </div>
        {/* 🔹 Label de salle : Bureau RH */}
        <div
          className="
            absolute left-4 top-4
            rounded-full
            bg-black/70 border border-white/15
            px-3 py-1
            text-[11px] tracking-[0.18em]
            uppercase text-slate-200
            z-10
          "
        >
          Bureau RH
        </div>
        {/* Image de fond */}
        <img
          src={backgroundUrl}
          alt="Bureau des ressources humaines"
          className="absolute inset-0 h-full w-full object-contain"
          onLoad={() => setBgReady(true)}
          onError={() => setBgReady(true)} // pour éviter blocage si erreur réseau
        />

        <div
          className={[
            "absolute inset-0 transition-opacity duration-200",
            bgReady ? "opacity-100" : "opacity-0 pointer-events-none",
          ].join(" ")}
        >
          {/* Coffre / registre des employés */}
          <img
            src={safeImg}
            alt="Coffre vérouillé"
            onClick={() => {
              markInspectedOnce('stage1player6:registerSafe');
              setShowRegisterModal(true);
              missionUnlock({
                key: "s1.p6.safe.found",
                text: `${pseudo} a trouvé un coffre mural vérouillé.`,
              });
            }}
            className="
              p6-register
              absolute cursor-pointer
              transition-all duration-200
              hover:brightness-150
              hover:drop-shadow-[0_0_6px_rgba(255,255,255,1)]
            "
          />

          <img
            src={postItImg}
            alt="Un post-it"
            onClick={() => {
              markInspectedOnce('stage1player6:postIt');
              setShowPostItModal(true);
            }}
            className="
              p6-postIt
              absolute cursor-pointer
              transition-all duration-200
              hover:brightness-150
              hover:drop-shadow-[0_0_6px_rgba(255,255,255,1)]
            "
          />
          <span className="p6-dices-shadow absolute"></span>
          <img
            src={dicesImg}
            alt="Des dés"
            onClick={() => {
              markInspectedOnce('stage1player6:dices');
              setShowCubesModal(true);
            }}
            className="
              p6-dices
              absolute cursor-pointer
              transition-all duration-200
              hover:brightness-150
              hover:drop-shadow-[0_0_6px_rgba(255,255,255,1)]
            "
          />

          {/* 🆕 Affiche RH / numérique responsable */}
          <img
            src={charterImg}
            alt="Affiche engagement RH & numérique responsable"
            onClick={() => {
              markInspectedOnce('stage1player6:charter');
              setShowCharterModal(true);
            }}
            className="
              p6-charter
              absolute cursor-pointer
              transition-all duration-200
              hover:brightness-130
              hover:drop-shadow-[0_0_6px_rgba(255,255,255,1)]
            "
          />

          <img
            src={drawerImg}
            alt="Meuble à tiroirs"
            onClick={() => {
              markInspectedOnce("stage1player6:drawer");
              setShowDrawerModal(true);
            }}
            className="
              p6-drawer
              absolute cursor-pointer
              transition-all duration-200
              hover:brightness-130
              hover:drop-shadow-[0_0_6px_rgba(255,255,255,1)]
            "
          />

          {/* Plante */}
          <img
            src={plantImg}
            alt="Plante verte"
            onClick={() => {
              markInspectedOnce("stage1player6:plant");
              setShowPlantModal(true);
            }}
            className="
              p6-plant
              absolute cursor-pointer
              transition-all duration-200
              hover:brightness-130
              hover:drop-shadow-[0_0_6px_rgba(255,255,255,1)]
            "
          />

          {/* Feuille au sol */}
          <img
            src={paperImg}
            alt="Feuille froissée au sol"
            onClick={() => {
              markInspectedOnce("stage1player6:paper");
              setShowPaperModal(true);
            }}
            className="
              p6-paper
              absolute cursor-pointer
              transition-all duration-200
              hover:brightness-130
              hover:drop-shadow-[0_0_6px_rgba(255,255,255,1)]
            "
          />

          {/* Tableau blanc */}
          <img
            src={whiteboardImg}
            alt="Tableau blanc"
            onClick={() => {
              markInspectedOnce("stage1player6:whiteboard");
              setShowWhiteboardModal(true);
            }}
            className="
              p6-whiteboard
              absolute cursor-pointer
              transition-all duration-200
              hover:brightness-130
              hover:drop-shadow-[0_0_6px_rgba(255,255,255,1)]
            "
          />

          {/* Tiroir bureau */}
          <img
            src={deskDrawerImg}
            alt="Tiroir du bureau"
            onClick={() => {
              markInspectedOnce("stage1player6:deskDrawer");
              setShowDeskDrawerModal(true);
            }}
            className="
              p6-desk-drawer
              absolute cursor-pointer
              transition-all duration-200
              hover:brightness-130
              hover:drop-shadow-[0_0_6px_rgba(255,255,255,1)]
            "
          />

        </div>
      </div>

      {/* 🔲 Modale des cubes / dés */}
      <Modal open={showCubesModal} title="Des dés" onClose={() => setShowCubesModal(false)} onHint={() => setShowHintModal(true)}>
        <div className="mb-2 flex items-center justify-between gap-2">
          <p className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
            Manipulation
          </p>
          <button
            type="button"
            onClick={() => setColorblindModeDicesP6(v => !v)}
            className={[
              "rounded-full px-3 py-1 text-[11px] border transition",
              colorblindModeDicesP6
                ? "bg-indigo-500/15 border-indigo-400/40 text-indigo-100"
                : "bg-white/5 border-white/10 text-slate-300 hover:bg-white/10",
            ].join(" ")}
            aria-pressed={colorblindModeDicesP6}
          >
            {colorblindModeDicesP6 ? "Mode daltonien : ON" : "Mode daltonien"}
          </button>
        </div>

        <p className="mb-3 text-sm text-gray-200">
          Trois dés sont posés sur le bureau...
        </p>

        <CubeGrabZone storageKey={`hint:cubes:${code}:${playerId}`}>
          <CubeLock onCubeClick={handleCubeClick} showTokens={colorblindModeDicesP6} />
        </CubeGrabZone>

        <p className="mt-3 text-[11px] text-gray-400">
          En observant attentivement les dés, tu remarques qu’une seule combinaison
          de valeurs semble vraiment cohérente. Peut-être que ces dés ne
          servent pas qu&apos;à jouer...
        </p>

        {colorblindModeDicesP6 && (
          <p className="mt-2 text-[11px] text-slate-300">
            Correspondance des couleurs : R = Rose · O = Orange · B = Bleu
          </p>
        )}
      </Modal>

      {/* Post-it indices de couleurs */}
      <Modal
        open={showPostItModal}
        title=""
        onClose={() => setShowPostItModal(false)}
        onHint={() => setShowHintModal(true)}
      >
        <div className="flex justify-center">
          <div
            className="
              relative
              w-64 h-64
              bg-[#FEF3C7]
              rounded-sm
              shadow-xl
              border border-yellow-300/80
              -rotate-2
            "
          >
            {/* Scotch */}
            <div
              className="
                absolute
                -top-3 left-1/2 -translate-x-1/2
                w-20 h-4
                bg-yellow-100/90
                rounded-[2px]
                shadow-sm
              "
            />

            {/* Contenu du post-it */}
            <div className="flex flex-col items-center justify-center h-full px-4 pt-4 space-y-3">
              <img
                src="/assets/p6_postit_dice.webp"
                alt="Schéma griffonné de dés"
                className="w-28 h-auto opacity-90"
              />

              <p
                className="
                  text-xl
                  text-slate-900
                  tracking-wide
                  -rotate-1
                "
                style={{
                  fontFamily:
                    '"Indie Flower", "Shadows Into Light", "Comic Sans MS", system-ui',
                }}
              >
                Rose – Orange – Bleu
              </p>
            </div>
          </div>
        </div>

        <p className="mt-4 text-xs text-gray-300 text-center">
          L&apos;écriture est nerveuse, avec des lettres irrégulières, comme griffonnée à la va-vite.
        </p>
      </Modal>

      {/* 📘 Modale du registre */}
      <ModalRegister
        open={showRegisterModal}
        title={hasRegistryAccess ? "Registre RH — Annuaire interne" : "Un coffre mural vérouillé"}
        onClose={() => {
          setShowRegisterModal(false);
          setSelectedEmployee(null);
        }}
        onHint={() => setShowHintModal(true)}
      >
        {!hasRegistryAccess ? (
          <>
            <p className="mb-2">
              Un coffre est fixé au mur. Il semble vérouillé et une
              petite fenêtre numérique attend un code.
            </p>

            <form onSubmit={handleCodeSubmit} className="mt-2 space-y-2 text-xs">
              <label className="block text-[11px] uppercase tracking-[0.18em] text-slate-400">
                Code du coffre
              </label>
              <div className="flex gap-2">
                <input
                  type="text"
                  maxLength={3}
                  value={codeInput}
                  onChange={(e) => {
                    setCodeInput(e.target.value.replace(/[^0-9]/g, ""));
                    setCodeError("");
                  }}
                  className="flex-1 px-3 py-2 rounded-lg bg-black/60 border border-white/20 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 font-mono tracking-[0.25em]"
                  placeholder="___"
                />
                <button
                  type="submit"
                  className="px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-xs font-semibold"
                >
                  Valider
                </button>
              </div>

              {codeError && (
                <p className="text-[11px] text-red-400">{codeError}</p>
              )}
            </form>
          </>
        ) : (
          <>
            <p className="mb-2 text-xs text-emerald-300">
              Un déclic discret se fait entendre : le coffre s&apos;ouvre et le registre
              glisse vers toi. Tu peux maintenant consulter les dossiers.
            </p>
            <p className="text-[11px] text-slate-400 mb-3 italic">
              Correspondance ID ↔ Employé(e)
            </p>
            <p className="text-[11px] text-gray-400 mb-3">
              Clique sur les informations d&apos;un employé pour accéder à plus de détails.
            </p>

            {/* 📎 Annexe : liste des animaux de compagnie (sans propriétaires) */}
            <div className="mb-3 rounded-lg bg-black/35 border border-white/10 p-3 text-xs">
              <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-amber-300 mb-1">
                Annexe indépendante — animaux déclarés
              </p>
              <p className="text-[11px] text-slate-300">
                Ce document est <span className="text-amber-200 font-semibold">séparé</span> du registre et semble concerner les animaux des employés.
              </p>

              <div className="mt-3 flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => {
                    setShowRegisterModal(false);
                    setShowAnimalsPuzzleModal(true);
                    markInspectedOnce?.("stage1player6:animalsAnnex");
                  }}
                  className="rounded-lg bg-indigo-600 hover:bg-indigo-500 px-3 py-2 text-xs font-semibold transition"
                >
                  Ouvrir l’annexe
                </button>

                {animalsClassified && (
                  <span className="text-xs text-emerald-300">✅ Annexe reconstituée</span>
                )}
              </div>
            </div>

            {selectedEmployee && (
              <div className="mt-3 rounded-lg bg-black/40 border border-white/10 p-3 text-xs">
                <p className="text-[11px] text-slate-400 mb-1 uppercase tracking-[0.16em]">
                  Détails
                </p>
                <p className="text-sm font-semibold">
                  {selectedEmployee.prenom} {selectedEmployee.nom}
                </p>
                <p className="text-[11px] text-slate-300">
                  ID {selectedEmployee.id} — {selectedEmployee.poste} (
                  {selectedEmployee.equipe})
                </p>
                <p className="mt-2 text-[11px] text-slate-400 italic">
                  {selectedEmployee.notes}
                </p>
              </div>
            )}

            <EmployeeRegister
              onEmployeeSelect={setSelectedEmployee}
              onEmployeeClick={(emp) => {
                // déclenchement mission guide sur l’employée cible
                if (Number(emp?.id) === 359) {
                  missionUnlock({
                    key: "s1.p6.employeeId.found",
                    text: `${pseudo} a trouvé que l'ID 359 est celui de Marie Dupont.`,
                  });
                }
              }}
            />


          </>
        )}
      </ModalRegister>

      {/* 🧾 Affiche RH / numérique responsable */}
      <Modal
        open={showCharterModal}
        title="Extrait – Charte RH & numérique responsable"
        onClose={() => setShowCharterModal(false)}
      >
        <p className="text-sm text-gray-200 mb-2">
          Une affiche officielle est posée sur le bureau. En bas, on lit :{" "}
          <span className="font-mono text-xs bg-black/60 px-2 py-1 rounded">
            “Engagement diversité, inclusion & numérique responsable”
          </span>
        </p>

        <ul className="mt-2 text-xs space-y-2 list-disc pl-4">
          <li>
            <span className="font-semibold">Diversité & inclusion :</span>{" "}
            recruter, accompagner et faire évoluer des profils variés. Refuser les
            discriminations, explicites ou implicites, y compris dans les algorithmes.
          </li>
          <li>
            <span className="font-semibold">Respect & feedback :</span>{" "}
            les retours, même difficiles, se font sans attaques personnelles,
            que ce soit entre collègues ou envers des systèmes d’IA en phase de test.
          </li>
          <li>
            <span className="font-semibold">Données sensibles :</span>{" "}
            limiter l’accès aux registres et journaux aux personnes habilitées, tracer
            les consultations et anonymiser quand c’est possible (RGPD & sécurité).
          </li>
          <li>
            <span className="font-semibold">Équilibre de vie :</span>{" "}
            droit à la déconnexion, rotation claire des astreintes, vigilance sur la
            charge mentale des équipes tech et produit.
          </li>
          <li>
            <span className="font-semibold">Origami :</span>{" "}
            l’assistant IA est conçu pour comprendre les nuances du langage et signaler
            les dérives, pas pour remplacer la responsabilité humaine dans la façon
            de parler aux équipes.
          </li>
        </ul>
      </Modal>
      <ModalRegister
        open={showDrawerModal}
        title="Meuble à tiroirs"
        onClose={() => setShowDrawerModal(false)}
        onHint={() => setShowHintModal(true)}
      >
        {!drawerUnlocked ? (
          <AnimalIconCodeLock
            expectedCode="6611"
            onUnlock={() => {
              setDrawerUnlocked(true);
              missionUnlock?.({ key: "s1.p6.drawer.unlocked", text: `${pseudo} a déverrouillé un tiroir RH.` });
            }}
            sessionCode={code}
            stage={1}
            playerId={playerId}
          />
        ) : (
          <EmpathieScannerPuzzle
            storageKey={`p6:drawer:empathie:${code}:${playerId}`}
            code={code}
            playerId={playerId}
            expectedWord="empathie"
            bonusLabel="Votre degré de compréhension du modèle empathie cognitive augmente, vous gagnez 300 points."
            onAttempt={({ ok }) => {
              if (!ok) {
                trackError?.({
                  sessionCode: code,
                  stage: 1,
                  playerId,
                  reason: "stage1_p6_empathie_wrong",
                });
              }
            }}
            onSuccess={() => {
              missionUnlock?.({
                key: "s1.p6.origami.bonus",
                text: `${pseudo} a obtenu un bonus Origami (+300 pts).`,
              });

              try {
                localStorage.setItem(`bonus:p6:empathie:${code}:${playerId}`, "300");
              } catch { }
            }}
          />
        )}
      </ModalRegister>

      <ModalRegister
        open={showAnimalsPuzzleModal}
        title="Annexe RH — classification des animaux"
        onClose={() => {
          setShowAnimalsPuzzleModal(false);
          setShowRegisterModal(true);
        }}
        onHint={() => setShowHintModal(true)}
      >
        <AnimalCategoriesPuzzle
          storageKey={`p6:animals:${code}:${playerId}`}
          onSuccess={() => {
            setAnimalsClassified(true);
            localStorage.setItem(`p6:animalsSolved:${code}:${playerId}`, "1");
            missionUnlock?.({
              key: "s1.p6.animals.classified",
              text: `${pseudo} a reconstitué la liste : chats/chiens/hamster/araignée.`,
            });
          }}
          onAttempt={({ ok }) => {
            if (!ok) {
              trackError?.({
                sessionCode: code,
                stage: 1,
                playerId,
                reason: "stage1_p6_animals_wrong_classification",
              });
            }
          }}
        />
      </ModalRegister>

      {/* Modale Plante */}
      <Modal
        open={showPlantModal}
        title="Plante verte"
        onClose={() => setShowPlantModal(false)}
        onHint={() => setShowHintModal(true)}
      >
        <p className="text-xs text-slate-300 mb-4">
          Une plante est posée sur le meuble. Ses feuilles ont des formes bien distinctes...
        </p>

        <div className="flex justify-center p-4 bg-gradient-to-b from-emerald-900/20 to-black/40 rounded-xl border border-emerald-500/20">
          <CompletePlant />
        </div>

      </Modal>

      {/* Modale Feuille fragments */}
      <Modal
        open={showPaperModal}
        title="Feuille froissée"
        onClose={() => setShowPaperModal(false)}
        onHint={() => setShowHintModal(true)}
      >
        <PlantFragmentPuzzle
          storageKey={`p6:fragments:${code}:${playerId}`}
          onSolved={({ code }) => {
            setFragmentCode(code);
            missionUnlock?.({
              key: "s1.p6.fragments.solved",
              text: `${pseudo} a reconstitué les fragments de la plante.`,
            });
          }}
        />
      </Modal>

      {/* Modale Tableau blanc */}
      <Modal
        open={showWhiteboardModal}
        title="Tableau blanc"
        onClose={() => setShowWhiteboardModal(false)}
        onHint={() => setShowHintModal(true)}
      >
        <ErasedWhiteboardPuzzle
          storageKey={`p6:whiteboard:${code}:${playerId}`}
          hasUvLamp={hasUvLamp} // ✅ Passe l'état de la lampe
          onSolved={() => {
            missionUnlock?.({
              key: "s1.p6.whiteboard.solved",
              text: `${pseudo} a découvert que le registre RH permet d'identifier les employés via leurs ID.`,
            });
          }}
        />
      </Modal>

      {/* Modale Tiroir bureau */}
      <ModalRegister
        open={showDeskDrawerModal}
        title="Tiroir du bureau"
        onClose={() => setShowDeskDrawerModal(false)}
        onHint={() => setShowHintModal(true)}
      >
        {!deskDrawerUnlocked ? (
          <form onSubmit={handleDeskDrawerSubmit} className="space-y-3">
            <p className="text-xs text-slate-300">
              Le tiroir est vérouillé par un cadenas à 5 chiffres.
            </p>

            <input
              type="text"
              maxLength={5}
              value={deskDrawerCode}
              onChange={(e) => {
                setDeskDrawerCode(e.target.value.replace(/[^0-9]/g, ""));
                setDeskDrawerError("");
              }}
              className="w-full px-3 py-2 rounded-lg bg-black/60 border border-white/20 text-sm font-mono tracking-widest"
              placeholder="_____"
            />

            <button
              type="submit"
              className="w-full rounded-lg bg-indigo-600 hover:bg-indigo-500 py-2 text-xs font-semibold"
            >
              Déverrouiller
            </button>

            {deskDrawerError && <p className="text-xs text-red-400">{deskDrawerError}</p>}
          </form>
        ) : (
          <div className="space-y-3">
            <p className="text-xs text-emerald-300">✅ Tiroir déverrouillé !</p>

            <div className="rounded-xl border border-white/10 bg-black/30 p-3">
              <p className="text-sm font-semibold text-slate-100 mb-2">
                📄 Guide d'onboarding RH
              </p>
              <p className="text-xs text-slate-300 leading-relaxed">
                Bienvenue chez Origami ! <br /><br />

                <span className="font-semibold text-amber-200">Accès au registre des employés :</span><br />
                Le registre principal est sécurisé dans le coffre mural.
                Les accessoires de bureau (dés, post-it) peuvent t'aider à trouver le code.<br /><br />

                <span className="text-slate-400 italic">
                  — Équipe RH
                </span>
              </p>
            </div>

            {/* Lampe UV trouvée */}
            <div className="rounded-xl border border-purple-400/30 bg-purple-500/10 p-3">
              <p className="text-sm font-semibold text-purple-200 mb-1">
                🔦 Lampe UV trouvée !
              </p>
              <p className="text-xs text-slate-300">
                Une petite lampe UV portative. Elle doit bien servir à quelque chose...
              </p>
            </div>
          </div>
        )}
      </ModalRegister>

      <OrigamiCommunicationModal
        open={showOrigamiReboot}
        text={rebootText}
        onClose={() => setShowOrigamiReboot(false)}
        autoClose={true}
        autoCloseDuration={10000}
      />

      {/* Modale d'indice */}
      <HintsModalHub
        open={showHintModal}
        onClose={closeHints}
        title={!hasRegistryAccess ? "Indices — Ouvrir le coffre" : "Indices — Bureau RH"}
        markHintUsedOnce={markHintUsedOnce}
        categories={hintCategories}
        usedStorageKey={usedStorageKey}
      />
    </div>
  );
}
